import System from "./System";
import { InventorySubmission } from "./Submission";
import { SubmissionPeriodOverdueSetting } from "./enums/SubmissionPeriodOverdueSetting";
import { SubmissionPeriodType } from "./enums/SubmissionPeriodType";

export interface SubmissionPeriod extends Record<string, unknown> {
  id: number;
  locked: boolean;
  lockedDate: string;
  dueDate: string;
  active: boolean;
  sandbox?: boolean;
  name: string;
  primacyAgencyId: number;
  serviceLineConnections: number;
  submissions: InventorySubmission[];
  systems: System[];
  modifiedOn: string;
  modifiedBy: string;
  createdOn: string;
  createdBy: string;
  submissionType: SubmissionPeriodType;
  overdueSetting: SubmissionPeriodOverdueSetting;
}

export const PERIOD_NAME_REGEX = /^(?:[qQ]\d ?- ?)?\d{4}$/;

export default SubmissionPeriod;
